(function () {
    'use strict';

    angular.module("imApp").factory("collectionMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1219,
                    parameters: parms || {}
                });
            },
            deleteItem: function (menu) {
                return $ihttp.post({
                    method: 1225,
                    parameters: menu
                });
            }
        };

        return service;
    }]);
})();
